/* eslint-disable camelcase */
import React from 'react';
import tw, { styled } from 'twin.macro';
import PropTypes from 'prop-types';
import { Progress } from 'semantic-ui-react';
import { defaultUserCustomTexts, toHex } from '../../shared/form-lib';

const ProgressBarContainer = styled.div`
  ${tw`mt-4 mb-4`}
  & .ui.progress>.label {
    color: var(--color) !important;
    font-family: var(--font-family) !important;
  }
`;

const ProgressBar = ({ color, formPages, percent, progressing, formDesign, currentPageNo, userCustomTexts }) => {
  const noOfPages = formPages.length;

  return (
    <>
      {noOfPages > 1 && (
        <ProgressBarContainer
          style={{
            '--color': toHex(formDesign?.old.form_text_color) || color,
            '--font-family': formDesign?.old.form_font,
          }}>
          <Progress size="small" active={progressing} progress percent={percent} autoSuccess>
            {noOfPages - currentPageNo} {userCustomTexts?.pages_left || defaultUserCustomTexts?.pages_left}
          </Progress>
        </ProgressBarContainer>
      )}
    </>
  );
};

ProgressBar.defaultProps = {
  currentPageNo: 1,
  progressing: false,
  formDesign: null,
};

ProgressBar.propTypes = {
  color: PropTypes.string,
  progressing: PropTypes.bool,
  currentPageNo: PropTypes.number,
  percent: PropTypes.number.isRequired,
  userCustomTexts: PropTypes.any.isRequired,
  formPages: PropTypes.arrayOf(PropTypes.any).isRequired,
  formDesign: PropTypes.shape({
    old: PropTypes.shape({
      form_text_color: PropTypes.string,
    }),
  }),
};

export default ProgressBar;
